export default class WarehouseService {
  constructor(axiosIns, serviceConfig) {
    this.axiosIns = axiosIns;
    this.serviceConfig = serviceConfig;
  }

  getAllWarehouses(args) {
    return this.axiosIns.get(this.serviceConfig.warehouses, { params: args });
  }

  createWarehouse(args) {
    return this.axiosIns.post(this.serviceConfig.warehouses, args);
  }

  getWarehouse(id) {
    return this.axiosIns.get(`${this.serviceConfig.warehouses}/${id}`);
  }

  editWarehouse(id, args) {
    return this.axiosIns.put(`${this.serviceConfig.warehouses}/${id}`, args);
  }
}
